/**
 * RequiredLabel — label з червоною зірочкою для обов'язкових полів.
 *
 * Використання:
 *   <RequiredLabel>Назва</RequiredLabel>
 *   <RequiredLabel required={false}>Опційно</RequiredLabel>
 */
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  required?: boolean;
}

export default function RequiredLabel({ children, required = true }: Props) {
  return (
    <label>
      {children}
      {required && (
        <span
          style={{ color: 'var(--danger, #dc2626)', marginLeft: '0.2rem' }}
          aria-label="обов'язкове поле"
          title="Обов'язкове поле"
        >
          *
        </span>
      )}
    </label>
  );
}
